module.exports = __webpack_public_path__ + "img/RightRedArrow.e4d5c001.svg";